var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.333,
    height: 16.5,
    viewBox: "0 0 18.333 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M2.75 16.5A2.75 2.75 0 0 1 0 13.912v-1.996a.917.917 0 0 1 1.827-.106l.006.106v1.834a.917.917 0 0 0 .81.91l.106.007h12.834a.918.918 0 0 0 .911-.81l.006-.106v-1.835a.917.917 0 0 1 1.827-.106l.006.106v1.834a2.749 2.749 0 0 1-2.588 2.75h-.162zm5.935-3.8a.915.915 0 0 1-.08-.056.921.921 0 0 1-.085-.075L3.935 7.982a.917.917 0 0 1 1.21-1.373l.086.076L8.25 9.7V.917A.917.917 0 0 1 10.077.81l.006.106V9.7L13.1 6.685a.918.918 0 0 1 1.21-.076l.086.076a.917.917 0 0 1 .077 1.21l-.077.087-4.581 4.583-.034.032-.017.015-.017.014-.017.014-.018.013a.917.917 0 0 1-1.023.041z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.fa0cd18bc068b4e9fe36b9139238b1a2.svg";
export { ForwardRef as ReactComponent };